<div class="container">


    <div class="login-container">
        <mat-card class="connections" *ngIf="connectionService.connections.length > 0">
            <mat-card-content>
                <div class="list" *ngFor="let connection of connectionService.connections">
                    <div (click)="switchTo(connection)" class="connection">{{connection.name}}</div>
                    <div class="server">{{connection.address}}</div>
                    <div class="action">
                        <button (click)="deleteConnection(connection)" mat-raised-button>Delete</button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-content>
                <div class="login">
                    <h2>Add Connection</h2>
        
                    <mat-form-field appearance="outline">
                        <mat-label>Server</mat-label>
                        
                        <input matInput placeholder="" [(ngModel)]="server" type="text">
                    </mat-form-field>
                                    
                    <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input (keyup.enter)="login()" matInput placeholder="" [(ngModel)]="password" type="password">
                    </mat-form-field>

                    <div>
                        <button (click)="login()" color="primary" mat-flat-button mat-button>Login</button>
                    </div>

                    <div *ngIf="connectionFailed" class="tryagain">Could not connect to server</div>
                    <div *ngIf="tryAgain == 1" class="tryagain">WRONG PASSWORD TRY AGAIN</div>
                    <div *ngIf="tryAgain == 2" class="tryagain">WRONG AGAIN!</div>
                    <div *ngIf="tryAgain == 3" class="tryagain">NO LUCK!?</div>
                    <div *ngIf="tryAgain == 4" class="tryagain">ASK SUMMER</div>
                    <div *ngIf="tryAgain == 5" class="tryagain">JUST MESSAGE SUMMER FFS</div>
                    <div *ngIf="tryAgain > 5" class="tryagain">JUST KEEP TRYING THEN OK...</div>
                </div>
            </mat-card-content>
          </mat-card>
    </div>

</div>